import { render, staticRenderFns } from "./ExamPrep.vue?vue&type=template&id=63c6e6e2&"
import script from "./ExamPrep.vue?vue&type=script&lang=js&"
export * from "./ExamPrep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports